import React, { useEffect } from "react";

interface GoogleAuthProps {
  onSuccess: (profile: { name: string; email: string; imageUrl?: string }) => void;
  onFailure: (error: any) => void;
}

const GOOGLE_CLIENT_ID = "417610796677-4ikdiummvdag5dvjkg0gtak2spu8sqv0.apps.googleusercontent.com";
const ALLOWED_EMAILS = [
  "tech@altinvest.ai",
  "hashim.khan@propertyshare.in",
  "kunal.moktan@propertyshare.in",
  "anurag.gaur@altinvest.ai",
  "apurva.sinha@altinvest.ai",
  "rahul.jain@altcapital.ai",
  "binoy.patel@altcapital.ai",
  "aditya.handigol@altinvest.ai",
  "adwaith.umesh@altcapital.ai"
];

declare global {
  interface Window {
    onGoogleSignIn?: (response: any) => void;
  }
}

const GoogleAuth: React.FC<GoogleAuthProps> = ({ onSuccess, onFailure }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      window.onGoogleSignIn = (response: any) => {
        if (response.credential) {
          const base64Url = response.credential.split(".")[1];
          const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split("")
              .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join("")
          );
          const profile = JSON.parse(jsonPayload);
          if (ALLOWED_EMAILS.includes(profile.email)) {
            onSuccess({ name: profile.name, email: profile.email, imageUrl: profile.picture });
          } else {
            onFailure("Email not allowed");
          }
        } else {
          onFailure("No credential returned");
        }
      };
      // @ts-ignore
      if (window.google && window.google.accounts) {
        // @ts-ignore
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: window.onGoogleSignIn,
        });
        // @ts-ignore
        window.google.accounts.id.renderButton(
          document.getElementById("google-signin-btn"),
          { theme: "outline", size: "large", width: "100%" }
        );
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [onSuccess, onFailure]);

  return <div id="google-signin-btn" style={{ width: "100%" }} />;
};

export default GoogleAuth;
